import React from 'react';
import TitleBar from './TitleBar';

const Window = ({
	title,
	onMinimize,
	onMaximize,
	onClose,
	onHelp,
	onContextMenu,
	maximised,
	children,
	onClick,
	appData,
	embeded,
	embedable,
	icon,
	isActiveWindow,
	metadata,
	windowA,
	...rest
}) => {
	const maximisedClass = maximised ? 'maximised' : '';
	const { license, embedMode } = appData || {};

	return (
		<div
			className={"window " + maximisedClass + (license ? ' win95' : '')}
			{...rest}
		>
			{!embeded && (
				<TitleBar
					title={title}
					onContextMenu={onContextMenu}
					onMinimize={onMinimize}
					onMaximize={onMaximize}
					onClose={onClose}
					onHelp={onHelp}
					isMaximized={maximised}
					onClick={onClick}
					appData={appData}
					embedMode={embedMode}
					embedable={embedable}
					embeded={embeded}
					icon={icon}
					isActiveWindow={isActiveWindow}
					metadata={metadata}
					windowA={windowA}
				/>
			)}
			{children}
		</div>
	);
};

export default Window;
